import { useState, useEffect } from "react";
// import { getContract } from "config/contracts";
import {callContract, contractFetcher } from "lib/contracts";
import Token from "abis/Token.json";
import { bigNumberify ,formatAmount} from "lib/numbers";
import { ethers } from "ethers";
import {  getProvider } from "lib/rpc";
import AnyswapV6Router from "abis/AnyswapV6Router.json";
import AnyswapV4Router from "abis/AnyswapV4Router.json";
import {  t } from "@lingui/macro";
import { InjectedConnector } from "@web3-react/injected-connector";

import {
    WalletConnectConnector,
  } from "@web3-react/walletconnect-connector";
import {
    OPETHMAIN_RPC_PROVIDERS,
    ETHMAIN_RPC_PROVIDERS
} from "config/chains";
const multiChainBaseServerUrl = "https://bridgeapi.multichain.org";
const anyswapBaseServerUrl = "https://bridgeapi.anyswap.exchange";
const NETWORKMAIN = 1;
const NETWORKOP = 10;
const ETH = "ETH";
const BTC = "BTC";
export const configScanPath = {
    1: "https://etherscan.io",
    10: "https://optimistic.etherscan.io"
}
const configChainsId = {
    'Ethereum': NETWORKMAIN,
    'Optimism':NETWORKOP
}
const configChaind  ={
    1:"Ethereum",
    10:"Optimism"
}
const multiChainConfigs = {
    1:{
        ETH: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        BTC: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
       
    },
    10:{
        ETH: "0x4200000000000000000000000000000000000006", 
        BTC: "0x68f180fcce6836688e9084f035309e29bf0a2095",
    }
};

const contractRouterAddress = {
    1: "0xba8da9dcf11b50b03fd5284f164ef5cdef910705",
    10: "0xdc42728b0ea910349ed3c6e1c9dc06b5fb591f98"
}
const routerv4 = {
    1:"0x6b7a87899490EcE95443e979cA9485CBE7E71522",
    10:"0xdc42728b0ea910349ed3c6e1c9dc06b5fb591f98"
}
const NETWORKS = [NETWORKMAIN,NETWORKOP];

const defaultFetchers = url => fetch(url).then(res => res.json())
function useRequest(url, defaultValue, fetcher = defaultFetchers) {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [data, setData] = useState(defaultValue)
    useEffect(async () => {
        try {
          if(!url){
            setLoading(false)
            return ;
          }
            setLoading(true)
            const data = await fetcher(url)
            setData(data)
        } catch (ex) {
            console.error(ex)
            setError(ex)
        }
        setLoading(false)
    }, [url])

    return [data, loading, error];
};
export function useBridgeToken(chainId) {
    const [data, setData] = useState(null);
    // https://bridgeapi.anyswap.exchange/v2/serverInfo/
    let url = getMultiChainServerUrl(`/v4/tokenlistv4/${chainId?chainId:NETWORKOP}`);
    const toChainId = chainId==NETWORKMAIN?NETWORKOP:NETWORKMAIN;
    useEffect(() => {
        defaultFetchers(url).then(userDataInfo=>{
        const evmBtcAddress = `evm${multiChainConfigs[chainId?chainId:NETWORKOP][BTC]}`;
        const evmEthAddress = `evm${chainId==NETWORKOP?"o":""}eth${multiChainConfigs[chainId?chainId:NETWORKOP][ETH]}`;
        if(chainId && userDataInfo){
            const btcTokenInfo =  userDataInfo[evmBtcAddress];
            const ethTokenInfo =  userDataInfo[evmEthAddress];
            const btcValues =  Object.entries(btcTokenInfo.destChains[toChainId]);
            const ethValues =  Object.entries(ethTokenInfo?.destChains[toChainId]);
            let toBTCValue = btcValues[0][1];
            toBTCValue.prices = btcTokenInfo.price;
            let toETHValues = ethValues[0][1];
            toETHValues.prices = ethTokenInfo.price;
            if(toBTCValue&&toETHValues){
                setData({
                    BTC: toBTCValue,
                    ETH: toETHValues
                    })
            }
        }
    }).catch(e =>console.log(e));

    },[chainId]);
    return {
        data: data || {
            BTC: 
            {
                BigValueThreshold: "0",
                DepositAddress: "",
                MaximumSwap: "0",
                MaximumSwapFee: "0",
                MinimumSwap: "0",
                MinimumSwapFee: "0",
                SwapFeeRatePerMillion:0.01,
                decimals: 8,
                prices:0,
                address:`${multiChainConfigs[toChainId][BTC]}`
            },
            ETH:   {
                BigValueThreshold: "0",
                DepositAddress: "",
                MaximumSwap: "0",
                MaximumSwapFee: "0",
                MinimumSwap: "0",
                MinimumSwapFee: "0",
                SwapFeeRatePerMillion:0.01,
                decimals: 18 ,
                prices:0,
                address:`${multiChainConfigs[toChainId][ETH]}`
            },
        }
      };
}

export async  function getBridgeToken(chainId) {
    // https://bridgeapi.anyswap.exchange/v2/serverInfo/
    let url = getMultiChainServerUrl(`/v4/tokenlistv4/${chainId?chainId:NETWORKOP}`);
    const toChainId = chainId==NETWORKMAIN?NETWORKOP:NETWORKMAIN;
        let userDataInfo = await  defaultFetchers(url);
        const evmBtcAddress = `evm${multiChainConfigs[chainId?chainId:NETWORKOP][BTC]}`;
        const evmEthAddress = `evm${chainId==NETWORKOP?"o":""}eth${multiChainConfigs[chainId?chainId:NETWORKOP][ETH]}`;
        if(chainId && userDataInfo){
            const btcTokenInfo =  userDataInfo[evmBtcAddress];
            const ethTokenInfo =  userDataInfo[evmEthAddress];
            const btcValues =  Object.entries(btcTokenInfo.destChains[toChainId]);
            const ethValues =  Object.entries(ethTokenInfo?.destChains[toChainId]);
            let toBTCValue = btcValues[0][1];
            toBTCValue.prices = btcTokenInfo.price;
            let toETHValues = ethValues[0][1];
            toETHValues.prices = ethTokenInfo.price;
            if(toBTCValue&&toETHValues){
                return { data: {
                    BTC: toBTCValue,
                    ETH: toETHValues
                    }}
            }
        }

    return {
        data:  {
            BTC: 
            {
                BigValueThreshold: "0",
                DepositAddress: "",
                MaximumSwap: "0",
                MaximumSwapFee: "0",
                MinimumSwap: "0",
                MinimumSwapFee: "0",
                SwapFeeRatePerMillion:0.01,
                decimals: 8,
                prices:0,
                address:`${multiChainConfigs[toChainId][BTC]}`
            },
            ETH:   {
                BigValueThreshold: "0",
                DepositAddress: "",
                MaximumSwap: "0",
                MaximumSwapFee: "0",
                MinimumSwap: "0",
                MinimumSwapFee: "0",
                SwapFeeRatePerMillion:0.01,
                decimals: 18 ,
                prices:0,
                address:`${multiChainConfigs[toChainId][ETH]}`
            },
        }
      };
}
function getMultiChainServerUrl(path){
    return `${multiChainBaseServerUrl+path}`;
}

function getAnyswapServerUrl(path){
    return `${anyswapBaseServerUrl+path}`;
}

export async function getTokenBalance(chainId,tokenAddress,library,account){

    const provider = getProvider(library, chainId);
    if(account&&provider){
        const contract = new ethers.Contract(tokenAddress, Token.abi, provider);
        return await contract.balanceOf(account);
    }
    return bigNumberify(0);
}

export async function getBalance(chainId,library,account){
    const provider = getProvider(library, chainId);
    if(provider){
        const data = await provider.getBalance(account);
        return data;
    }
    return bigNumberify(0);
}

export async function getTokenApprove(chainId,library,account,tokenAddress){
    const provider = getProvider(library, chainId);
    if(provider){
        const contract = new ethers.Contract(tokenAddress, Token.abi, provider);
        return await contract.allowance(account,contractRouterAddress[chainId]);
    }
    return bigNumberify(0);
    ;
}

export async function  getSwapTx(tx){
    return await defaultFetchers(getAnyswapServerUrl(`/v2/history/details?params=${tx}`));
 
}

export function sendAnySwapOutNative(anyETH, account ,chainId, toChain, amount,library,setIsSendTx,setSwapTx,setTradeModalVisible,setBridgeSwapTx,bridgeSwapTx,
    setConfirmModalVisible){
    const contract = new ethers.Contract(contractRouterAddress[chainId], AnyswapV6Router.abi, library.getSigner());
    let params = [anyETH,account, toChain];
    let value = amount;
    callContract(chainId, contract, "anySwapOutNative", params, {
        value,
        sentMsg: "Bridge router submitted!" ,
        successMsg: t`Bridge ${formatAmount(amount, 18, 4, true)} !`,
        failMsg: t`Bridge failed.`,
    })
    .then(async (tx) => {
        await tx.wait();
        setIsSendTx(false);
        setBridgeSwapTx([...bridgeSwapTx,tx.hash]);
        getSwapTx(tx.hash).then(swapTx=>{
            if(swapTx.error){
                swapTx.info={
                fromChainID : chainId,
                toChainID :  toChain,
                txid : tx.hash,
                formatvalue : formatAmount(amount, 8, 4, true),
                formatswapvalue : "-",
                time : "0",
                pairid : "ETH",
            }
            }
            console.log(swapTx.info);
            setSwapTx(swapTx.info);
            setTradeModalVisible(true);
            setConfirmModalVisible(false);
        });
    }).catch(e=>{
        setIsSendTx(false);
    })
}

export function senAnySwapOutUnderlying( account ,token,chainId, toChain, amount,library,setIsSendTx,setSwapTx,setTradeModalVisible,setBridgeSwapTx,bridgeSwapTx,setConfirmModalVisible){
    const contract = new ethers.Contract(routerv4[chainId], AnyswapV4Router.abi, library.getSigner());
    let params = [token,account, amount , toChain];
    let value = 0
    callContract(chainId, contract, "anySwapOutUnderlying", params, {
        value,
        sentMsg: "Bridge router submitted!" ,
        successMsg: t`Bridge ${formatAmount(amount, 8, 4, true)} !`,
        failMsg: t`Bridge failed.`,
    })
    .then(async  (tx) => {
        await tx.wait();
        setBridgeSwapTx([...bridgeSwapTx,tx.hash]);
        setIsSendTx(false);
        getSwapTx(tx.hash).then(swapTx=>{
            if(swapTx.error){
                swapTx.info={
                fromChainID : chainId,
                toChainID :  toChain,
                txid : tx.hash,
                formatvalue : formatAmount(amount, 8, 4, true),
                formatswapvalue : "-",
                time : "0",
                pairid : "BTC",
            }
            }
            console.log(swapTx.info);
            setSwapTx(swapTx.info);
            setTradeModalVisible(true);
            setConfirmModalVisible(false)
            return ;
        });
    })
    .catch(() => {
        setIsSendTx(false);
    });
}
export function sendApprove(chainId ,tokenAddress,library,setIsApprove,setIsUpdate){
    const contract = new ethers.Contract(tokenAddress, Token.abi, library.getSigner());
    let params = [contractRouterAddress[chainId], ethers.constants.MaxUint256];
    let value = 0;
    callContract(chainId, contract, "approve", params, {
        value,
        sentMsg: "Bridge sendApprove submitted!" ,
        successMsg: t`Bridge sendApprove ${formatAmount(ethers.constants.MaxUint256, 18, 4, true)} !`,
        failMsg: t`Bridge failed.`,
    }).then(()=>{
        setIsUpdate(true);
    })
    .finally(() => {
        setIsApprove(false);
    });
}


export function getConfigChainsIdByName(chainName){
    return configChainsId[chainName]?configChainsId[chainName]:NETWORKMAIN;
}

export function getConfigChainNamedById(chainId){
    return configChaind[chainId];
}

export function getConfigCSAByName(chainName,symbol){
    return  multiChainConfigs[configChainsId[chainName]?configChainsId[chainName]:NETWORKMAIN][symbol];
}
const injectedConnector = new InjectedConnector({
    supportedChainIds: [NETWORKMAIN,NETWORKOP],
  });
  
export function getBridgeInjectedConnector() {
    return injectedConnector;
}

export const getBridgeWalletConnectConnector = () => {
    const chainId =  NETWORKMAIN || NETWORKOP;
    return new WalletConnectConnector({
      rpc: {
        // [AVALANCHE]: AVALANCHE_RPC_PROVIDERS[0],
        // [ARBITRUM]: ARBITRUM_RPC_PROVIDERS[0],
        // [ARBITRUM_TESTNET]: "https://rinkeby.arbitrum.io/rpc",
        // [FTMTEST]: FTM_TEST_RPC_PROVIDERS[0],
        [NETWORKOP]: OPETHMAIN_RPC_PROVIDERS[0],
        [NETWORKMAIN]: ETHMAIN_RPC_PROVIDERS[0]

      },
      qrcode: true,
      chainId,
    });
  };